<template>
  <div
    class="alert"
    :class="`alert--${computedVariant}`"
    role="alert"
  >
    <div class="alert__main">
      <div class="alert__title">
        <jade-icon
          class="alert__icon"
          color="on-color-high"
          size="medium"
          :use="icon"
        >
        </jade-icon>
        <strong>{{ title }}</strong>
      </div>
      <div
        v-if="message"
        class="alert__content"
      >
        <p>{{ message }}</p>
      </div>
      <template v-if="isTestAccount">
        <a
          class="alert__help"
          v-if="helpLink"
          :href="helpLink.href"
          target="_blank"
          :title="helpLink.text"
        >
          {{ helpLink.text }}
          <jade-icon
            color="on-color-high"
            size="small"
            use="arrow-north-east"
          >
          </jade-icon>
        </a>
      </template>
      <jade-icon-button
        class="alert__close"
        v-if="dismissible"
        size="small"
        icon="close"
        variant="on-brand-ghost"
        @click="$emit('close')"
      >
      </jade-icon-button>
    </div>
  </div>
</template>
<script>
import { JadeIconButton, JadeIcon } from '@/components/jade'
export default {
  name: 'AccountsStatusAlertContainer',
  components: {
    JadeIconButton,
    JadeIcon
  },
  props: {
    isTestAccount: Boolean,
    title: String,
    message: String,
    helpLink: Object,
    dismissible: Boolean
  },
  computed: {
    computedVariant () {
      return this.isTestAccount ? 'testAccount' : 'productionAccount'
    },
    icon () {
      return this.isTestAccount ? 'warning' : 'circle-check'
    }
  }
}
</script>
<style scoped>
.alert {
  display: flex;
  align-items: center;
  padding: 0 var(--global-space-300);
  color: white;
  position: sticky;
  width: 100%;
  z-index: 1000;
  height: calc(var(--global-space-500) + var(--global-space-50));
  top: 0;
}
.alert--testAccount {
  background-color: var(--global-color-violet-3);
}
.alert--productionAccount {
  background-color: var(--theme-color-background-positive);
}
.alert__main {
  display: flex;
  width: 100%;
  line-height: var(--theme-size-xsmall);
}
.alert__title {
  display: flex;
  align-items: center;
}
.alert__icon {
  height: var(--global-space-250);
  margin-right: var(--global-space-100);
}
.alert__content {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.alert__help {
  display: flex;
  align-items: center;
  margin-left: var(--global-space-100);
}
.alert__help:hover {
  text-decoration: underline;
}
.alert__help span {
  height: var(--global-space-200);
  margin-left: var(--global-space-50);
}
.alert__close {
  margin-left: var(--global-space-100);
}
@media only screen and (max-width: 767px) {
  .alert {
    padding: 0 var(--global-space-50);
    z-index: 1001;
  }
  .alert__content > p {
    display: none;
  }
}
</style>
